interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onPageChange }: PaginationProps) {
  const getPages = () => {
    const pages: (number | string)[] = [];
    const delta = 2;

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - delta && i <= currentPage + delta)) {
        pages.push(i);
      } else if (pages[pages.length - 1] !== '...') {
        pages.push('...');
      }
    }
    return pages;
  };

  if (totalPages <= 1) return null;

  return (
    <nav aria-label="分页导航" className="flex items-center justify-center gap-2 mt-10">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="w-9 h-9 flex items-center justify-center rounded-lg text-sm text-foreground-600 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line w-4 h-4 flex items-center justify-center"></i>
      </button>

      {getPages().map((page, i) =>
        typeof page === 'string' ? (
          <span key={`dots-${i}`} className="w-9 h-9 flex items-center justify-center text-sm text-foreground-400">
            ...
          </span>
        ) : (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`w-9 h-9 flex items-center justify-center rounded-lg text-sm transition-colors cursor-pointer ${
              page === currentPage
                ? 'bg-primary-500 text-background-50 font-semibold'
                : 'text-foreground-600 hover:bg-background-100'
            }`}
          >
            {page}
          </button>
        )
      )}

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="w-9 h-9 flex items-center justify-center rounded-lg text-sm text-foreground-600 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
      </button>
    </nav>
  );
}